<template>
	<div class="text-gray-700 focus-within:text-orange-500"
	>
		<div class="flex justify-between flex-wrap gap-x-2" v-if="!noLabel">
			<label class="block font-medium" :for="inputId">{{ __(label) }}</label>
			<span class="text-gray-500" v-if="!required && !disabled && !markInvalid && !inValid">optional</span>
		</div>
		<div class="mt-1 relative">
			<ui-month-input
				@opened="form && field && typeof form.clearErrors === 'function' ? form.clearErrors(field) : null"
				v-model="val"
				:minDate="minDate"
				:maxDate="maxDate"
				:markInvalid="markInputInvalid || inValid"
				:verticalAlignment="verticalAlignment"
				:disabled="disabled"
			/>
		</div>
		<span class="text-red-600" v-if="inValid">{{ firstValidationError }}</span>
		<span class="text-red-600" v-else-if="markInvalid">{{ validationMessage }}</span>
	</div>
</template>

<script>
import UiInputGroup from "./InputGroup.vue";
export default {
	mixins: [UiInputGroup],
	props: {
		minDate: {
			type: String,
			default: "0000-00-01",
		},
		maxDate: {
			type: String,
			default: "9999-00-01",
		},
		verticalAlignment: {
			type: String,
			default: "top",
		},
	},
	computed: {
		monthLabels() {
			return this.$cropOptions.monthLabelsEn; // TODO i18n
		},
	},
};
</script>
